import $ from 'jquery';
import analytics from '../utils/analytics';

class Common {
    constructor() {

    }

    init() {
        this.bindEvents();     
        this.navigationClickEvent();
        this.footerNavigationClickEvent();
        this.socialClickEvent();
        this.initExternalLinks();
    }

    bindEvents() {
    }

    navigationClickEvent() {
        $('.primary-nav .nav-item').on('click', (e) => {
            const target = $(e.currentTarget);
            const parentText = target.parents('.js-nav-megamenu').data('parent-text');
            let menuText = '';

            if (parentText !== undefined && parentText !== '') {
                menuText = `${parentText} - ${target.data('text')}`;
            }
            else {
                menuText = target.data('text');
            }

            let data = {
                menu_type: target.data('type'),
                menu_clicktext: menuText
            };

            analytics.gtmClickEvent('navigationTracking', data);
        });
    }

    footerNavigationClickEvent() {
        $('.footer-column-navigation a, .footer-meta-list a').on('click', (e) => {
            const target = $(e.currentTarget);
            const parentText = target.data('parent-text');
            let menuText = '';

            if (parentText !== undefined && parentText !== '') {
                menuText = `${parentText} - ${target.data('text')}`;
            }
            else {
                menuText = target.data('text');
            }

            let data = {
                menu_type: target.data('type'),
                menu_clicktext: menuText
            };

            analytics.gtmClickEvent('navigationTracking', data);
        });
    }

    socialClickEvent() {
        $('.footer-column-social-item a, .social-icons a').on('click', (e) => {
            const target = $(e.currentTarget);

            let data = {
                type: target.data('type'),
                social_media: target.data('social')
            };

            analytics.gtmClickEvent('socialInteraction', data);
        });
    }

    initExternalLinks() {
        $('a:not(.open-self)').each((index, element) => {
            let a = new RegExp(`/${window.location.host}/`);

            if (!a.test(element.href) && element.href !== '') {
                $(element).click((event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    window.open(element.href, '_blank');
                });
            }
        });
    }  
}

export default Common;